/**
 * ============================================================
 * Deutsch
 * ============================================================
 *
 * Translators:
 *
 * increpare <analytic@gmail.com>
 * KazutoSensei
 */

export default {
	'AdvanceHelp': 'Um dich durch das Spiel zu navigieren, drücke die Leertaste oder klicke',
	'AllowPlayback': 'Click here to allow audio playback',
	'Audio': 'Audio',
	'AutoPlay': 'Auto',
	'AutoPlayButton': 'Enable auto play',
	'AutoPlaySpeed': 'AutoPlay-Geschwindigkeit',

	'Back': 'Zurück',
	'BackButton': 'Zurück',

	'Cancel': 'Abbrechen',
	'Close': 'Schließen',
	'Confirm': 'Möchtest Du das Spiel verlassen?',
	'Credits': 'Credits',

	'Delete': 'Löschen',
	'DialogLogButton': 'Show the dialog log',

	'FullScreen': 'Vollbildmodus',

	'Gallery': 'Gallery',

	'Help': 'Hilfe',
	'Hide': 'Verbergen',
	'HideButton': 'Text verbergen',

	'iOSAudioWarning': 'Audioeinstellungen werden unter iOS nicht unterstützt',

	'KeyboardShortcuts': 'Keyboard Shortcuts',

	'Language': 'Sprache',
	'Load': 'Laden',
	'LoadAutoSaveSlots': 'Automatisch gespeicherte Spiele',
	'LoadButton': 'Öffne den Ladebildschirm',
	'Loading': 'Lädt',
	'LoadingMessage': 'Bitte warte, während die Assets geladen werden',
	'LoadSlots': 'Gespeicherte Spiele',
	'LocalStorageWarning': 'Lokaler Speicher ist in diesem Browser nicht verfügbar',
	'Log': 'Log',

	'Music': 'Musik-Lautstärke',

	'NewContent': 'There is new content available, reload the page to get the latest version',
	'NoSavedGames': 'Keine gespeicherten Spiele',
	'NoAutoSavedGames': 'Keine automatisch gespeicherten Spiele',
	'NoDialogsAvailable': 'No dialogs available. Dialogs will appear here as they show up',

	'OK': 'OK',
	'OrientationWarning': 'Um das Spiel zu spielen, Bitte drehen sie Ihr Gerät',
	'Overwrite': 'Überschreiben',

	'QuickButtons': 'Schnellmenü Schaltflächen',
	'QuickMenu': 'Quick Menu',
	'Quit': 'Verlassen',
	'QuitButton': 'Spiel verlassen',

	'Resolution': 'Auflösung',

	'Save': 'Speichern',
	'SaveButton': 'Öffne den Speicherbildschirm',
	'SaveInSlot': 'In Slot speichern',
	'Settings': 'Optionen',
	'SettingsButton': 'Öffne die Optionen',
	'Show': 'Einblenden',
	'Skip': 'Skip',
	'SkipButton': 'Enter skip mode',
	'SlotDeletion': 'Bist Du sicher, dass Du diesen Slot löschen möchtest?',
	'SlotOverwrite': 'Bist Du sicher, dass Du diesen Slot überschreiben möchtest?',
	'Sound': 'Sound-Lautstärke',
	'Start': 'Start',
	'Stop': 'Stop',

	'TextSpeed': 'Textgeschwindigkeit',

	'Video': 'Video Volume',
	'Voice': 'Stimmen-Lautstärke',

	'Windowed': 'Fenstermodus'
};